import {StatusAggregationActions, StatusAggregationActionTypes} from '../actions/status-aggregation.actions';
import {StatusPeakLog} from '../status.model';

export interface StatusAggregationState {
  Loaded: boolean;
  Loading: boolean;
  entities: StatusPeakLog[];
}

export const initialState: StatusAggregationState = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(state = initialState, action: StatusAggregationActions): StatusAggregationState {
  switch (action.type) {
    case StatusAggregationActionTypes.GetStatusAggregations:
      return {...state, Loaded: false, Loading: true};
    case StatusAggregationActionTypes.LoadStatusAggregations:
      return {...state, Loaded: true, Loading: false, entities: action.payload};
    case StatusAggregationActionTypes.GetStatusAggregationsFail:
      return {...state, Loaded: true, Loading: false, entities: []};

    default:
      return state;
  }
}
